module.exports = __webpack_public_path__ + "static/media/back-with-black-bg.8b23faea.svg";